let host;
if (process.env.NODE_ENV === 'production') {
  if (process.env.CUSTOM_ENV === 'test') {
    host = 'https://t-hsy-merchant.lepass.cn/merchant-manager'; // 测试环境
  } else if (process.env.CUSTOM_ENV === 'pre') {
    host = 'https://p-hsy-merchant.lepass.cn/merchant-manager'; // 预发布环境
  } else if (process.env.CUSTOM_ENV === 'prd') {
    host = 'https://hsy-merchant.leshuazf.com/merchant-manager'; // 正式环境
  } else if (process.env.CUSTOM_ENV === 'dev') {
    host = 'https://d-hsy-merchant.lepass.cn/merchant-manager'; // 正式环境
  }
} else {
  host = "http://localhost:8082/merchant-manager";
  // host = "http://10.8.17.43:8669/merchant-manager";
}

const fileStatus = {
  0: '生成中',
  1: '生成成功',
  2: '文件数据为空',
  3: '生成失败',
};

const timeList = [
  {
    value: "9:00",
    label: "9:00",
  },
  {
    value: "10:00",
    label: "10:00",
  },
  {
    value: "11:00",
    label: "11:00",
  },
  {
    value: "12:00",
    label: "12:00",
  },
  {
    value: "13:00",
    label: "13:00",
  },
  {
    value: "14:00",
    label: "14:00",
  },
  {
    value: "15:00",
    label: "15:00",
  },
  {
    value: "16:00",
    label: "16:00",
  },
  {
    value: "17:00",
    label: "17:00",
  },
  {
    value: "18:00",
    label: "18:00",
  },
  {
    value: "19:00",
    label: "19:00",
  },
  {
    value: "20:00",
    label: "20:00",
  },
  {
    value: "21:00",
    label: "21:00",
  },
  {
    value: "22:00",
    label: "22:00",
  },
  {
    value: "23:00",
    label: "23:00",
  },
];

const payColor = {
  支付宝: "#0084FF",
  微信: "#17CE87",
  云闪付: "#F36361",
  银联: "#ff9c00",
  数字人民币: '#b3b3b3',
};

module.exports = {
  host,
  fileStatus,
  timeList,
  payColor,
};
